<template>
    <div style="background:#fff; padding:20px;">
        <div style="margin-bottom: 20px">
            <a-input v-model="queryParam.username" placeholder="请输入用户名" style="width: 200px; margin-right: 10px" />
            <a-button type="primary" @click="loadData" icon="search">查询</a-button>
            <a-button type="primary" style="margin-left: 10px" @click="handleAdd" icon="plus">新增用户</a-button>
        </div>

        <a-table :columns="columns" :data-source="data" :pagination="pagination" :loading="loading" rowKey="id"
            @change="handleTableChange">
            <span slot="status" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '正常' : '禁用' }}</a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="handleResetPwd(record)">重置密码</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="handleDelete(record.id)">
                    <a style="color: red">删除</a>
                </a-popconfirm>
            </span>
        </a-table>

        <a-modal v-model="visible" :title="modalTitle" @ok="handleOk">
            <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item label="用户名" prop="username">
                    <a-input v-model="form.username" :disabled="!!form.id" />
                </a-form-model-item>
                <a-form-model-item label="昵称" prop="nickname">
                    <a-input v-model="form.nickname" />
                </a-form-model-item>
                <a-form-model-item label="密码" prop="password" v-if="!form.id">
                    <a-input-password v-model="form.password" />
                </a-form-model-item>
                <a-form-model-item label="状态" prop="status">
                    <a-radio-group v-model="form.status">
                        <a-radio :value="1">正常</a-radio>
                        <a-radio :value="0">禁用</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="角色" prop="roleIds">
                    <a-select v-model="form.roleIds" mode="multiple" placeholder="请选择角色">
                        <a-select-option v-for="role in roleList" :key="role.id" :value="role.id">
                            {{ role.roleName }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <a-modal v-model="pwdVisible" title="重置密码" @ok="submitResetPwd">
            <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item label="新密码">
                    <a-input-password v-model="newPassword" placeholder="请输入新密码" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import {
        getUserList,
        getUser,
        addUser,
        updateUser,
        deleteUser,
        getRoleList,
        resetUserPassword
    } from '@/api'
    import { retreatPageAfterDelete } from '@/utils/pagination'

    export default {
        data() {
            return {
                queryParam: {
                    username: ''
                },
                data: [],
                roleList: [],
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                loading: false,
                visible: false,
                pwdVisible: false,
                currentUserId: null,
                modalTitle: '',
                form: {},
                rules: {
                    username: [{
                        required: true,
                        message: '必填'
                    }],
                    password: [{
                        required: true,
                        message: '必填'
                    }],
                    roleIds: [{
                        required: true,
                        message: '请选择至少一个角色',
                        type: 'array'
                    }]
                },
                columns: [{
                    title: 'ID',
                    dataIndex: 'id'
                }, {
                    title: '用户名',
                    dataIndex: 'username'
                }, {
                    title: '昵称',
                    dataIndex: 'nickname'
                }, {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: {
                        customRender: 'status'
                    }
                }, {
                    title: '操作',
                    key: 'action',
                    scopedSlots: {
                        customRender: 'action'
                    }
                }]
            }
        },
        created() {
            this.loadData()
            this.loadRoles()
        },
        methods: {
            loadData() {
                this.loading = true
                const params = {
                    page: this.pagination.current,
                    pageSize: this.pagination.pageSize,
                    ...this.queryParam
                }
                getUserList(params).then(res => {
                    this.data = res.data.list
                    this.pagination.total = res.data.total
                    this.loading = false
                })
            },
            loadRoles() {
                getRoleList().then(res => {
                    this.roleList = res.data
                })
            },
            handleTableChange(pagination) {
                this.pagination.current = pagination.current
                this.loadData()
            },
            handleAdd() {
                this.modalTitle = '新增用户'
                this.form = {
                    status: 1,
                    roleIds: []
                } // 重置表单
                this.visible = true
            },
            handleDelete(id) {
                deleteUser({
                    id
                }).then(() => {
                    this.$message.success('删除成功')
                    retreatPageAfterDelete(this.pagination, this.data.length)
                    this.loadData()
                })
            },
            handleEdit(record) {
                this.modalTitle = '编辑用户';
                this.visible = true;

                // 1. 初始化表单，清空旧数据
                this.form = { ...record, roleIds: [] };

                // 2. 调用接口获取最新数据 (主要是为了获取 roleIds)
                getUser(record.id).then(res => {
                    const { user, roleIds } = res.data;
                    // 合并数据：后端返回的user信息 + 角色列表
                    this.form = {
                        ...user,
                        roleIds: roleIds
                    };
                });
            },

            // 【修改】提交事件：区分新增(add) 和 修改(update)
            handleOk() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        // 判断是新增还是修改
                        const isEdit = !!this.form.id;
                        const api = isEdit ? updateUser : addUser;

                        // 构造提交数据
                        const data = {
                            id: this.form.id,
                            username: this.form.username,
                            nickname: this.form.nickname,
                            status: this.form.status,
                            roleIds: this.form.roleIds,
                            password: this.form.password // 修改模式下后端会忽略此字段
                        };

                        api(data).then(() => {
                            this.$message.success('操作成功');
                            this.visible = false;
                            this.loadData();
                        });
                    }
                })
            },
            handleResetPwd(record) {
                this.currentUserId = record.id;
                this.newPassword = '';
                this.pwdVisible = true;
            },
            // 提交重置
            submitResetPwd() {
                if (!this.newPassword || this.newPassword.length < 6) {
                    this.$message.error('密码长度至少6位');
                    return;
                }
                resetUserPassword({
                    id: this.currentUserId,
                    password: this.newPassword
                }).then(() => {
                    this.$message.success('密码重置成功');
                    this.pwdVisible = false;
                });
            }
        }
    }
</script>
